module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "header-menu"
  }, [_c('div', {
    staticClass: "header-menu-item"
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _vm._v(" 手机扫码玩\n        "), _c('div', {
    staticClass: "header-menu-item__qrcode"
  }, [_c('vue-qr', {
    attrs: {
      "text": _vm.url,
      "size": 200
    }
  })], 1)]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-menu-item"
  }, [_c('a', {
    attrs: {
      "href": "//www.bqrdh.com",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("主站")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b89c116"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/index.vue
// module id = 143
// module chunks = 1